import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { getDefaultLabelName } from '~/services/DefaultLabelNameService';
import { IBaseComponent } from '~/sharedInterfaces/IBaseComponent';
import { IState } from '~/sharedInterfaces/IState';

interface IRlcRedirectProps extends IBaseComponent {}

const RlcRedirect: FC<IRlcRedirectProps> = ({ componentName }) => {
  const { locale } = useSelector((state: IState) => state.widgetContext);
  const { start, urlText, url, end } = getDefaultLabelName(locale, componentName);

  return (
    <div className="qred-component qred-rlcredirect">
      <svg
        width="14"
        height="14"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M182.312 187.5H174.5V9.375C174.5 4.19727 170.303 0 165.125 0H33.875C28.6973 0 24.5 4.19727 24.5 9.375V187.5H16.6875C14.0988 187.5 12 189.599 12 192.188V200H187V192.188C187 189.599 184.901 187.5 182.312 187.5ZM62 29.6875C62 27.0988 64.0988 25 66.6875 25H82.3125C84.9012 25 87 27.0988 87 29.6875V45.3125C87 47.9012 84.9012 50 82.3125 50H66.6875C64.0988 50 62 47.9012 62 45.3125V29.6875ZM62 67.1875C62 64.5988 64.0988 62.5 66.6875 62.5H82.3125C84.9012 62.5 87 64.5988 87 67.1875V82.8125C87 85.4012 84.9012 87.5 82.3125 87.5H66.6875C64.0988 87.5 62 85.4012 62 82.8125V67.1875ZM82.3125 125H66.6875C64.0988 125 62 122.901 62 120.312V104.688C62 102.099 64.0988 100 66.6875 100H82.3125C84.9012 100 87 102.099 87 104.688V120.312C87 122.901 84.9012 125 82.3125 125ZM112 187.5H87V154.688C87 152.099 89.0988 150 91.6875 150H107.312C109.901 150 112 152.099 112 154.688V187.5ZM137 120.312C137 122.901 134.901 125 132.312 125H116.688C114.099 125 112 122.901 112 120.312V104.688C112 102.099 114.099 100 116.688 100H132.312C134.901 100 137 102.099 137 104.688V120.312ZM137 82.8125C137 85.4012 134.901 87.5 132.312 87.5H116.688C114.099 87.5 112 85.4012 112 82.8125V67.1875C112 64.5988 114.099 62.5 116.688 62.5H132.312C134.901 62.5 137 64.5988 137 67.1875V82.8125ZM137 45.3125C137 47.9012 134.901 50 132.312 50H116.688C114.099 50 112 47.9012 112 45.3125V29.6875C112 27.0988 114.099 25 116.688 25H132.312C134.901 25 137 27.0988 137 29.6875V45.3125Z"
          fill="black"
        />
      </svg>

      <p className="qred-first">
        <span className="qred-first">
          {start}
          <a href={url} target="_blank" rel="noreferrer">
            {urlText}
          </a>
          {end}
        </span>
      </p>
    </div>
  );
};

export default RlcRedirect;
